import { User } from 'firebase/auth'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { mapFirebaseError } from 'src/helpers/fireBaseErrorMaper'

import { AuthState } from 'src/store/reducers/AuthReducer/types'

const initialState: AuthState = {
  user: null,
  loading: false,
  error: null,
  showRegistrationPopup: false,
}

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    loginStart: state => {
      state.loading = true
      state.error = null
    },
    loginSuccess: (state, action: PayloadAction<Partial<User>>) => {
      state.user = action.payload
      state.loading = false
      state.error = null
    },
    clearUser(state) {
      state.user = null
      state.loading = false
    },
    authError: (state, action: PayloadAction<string>) => {
      state.loading = false
      state.error = mapFirebaseError(action.payload)
    },
    logoutSuccess: state => {
      state.user = null
      state.loading = false
      state.error = null
    },
    showPostRegiPopup(state) {
      state.showRegistrationPopup = true
    },
    hidePostRegiPopup(state) {
      state.showRegistrationPopup = false
    },
  },
})

export const {
  loginStart,
  loginSuccess,
  authError,
  logoutSuccess,
  clearUser,
  showPostRegiPopup,
  hidePostRegiPopup,
} = authSlice.actions

export default authSlice.reducer
